/* tslint:disable */
/* eslint-disable */
/**
 * resident-resources
 * resident-resources
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableRoomListEntry
 */
export interface AvailableRoomListEntry {
    /**
     * 
     * @type {string}
     * @memberof AvailableRoomListEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableRoomListEntry
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableRoomListEntry
     */
    billing_product_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableRoomListEntry
     */
    type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AvailableRoomListEntry
     */
    is_available: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AvailableRoomListEntry
     */
    is_configured: boolean;
}

/**
 * Check if a given object implements the AvailableRoomListEntry interface.
 */
export function instanceOfAvailableRoomListEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "is_available" in value;
    isInstance = isInstance && "is_configured" in value;

    return isInstance;
}

export function AvailableRoomListEntryFromJSON(json: any): AvailableRoomListEntry {
    return AvailableRoomListEntryFromJSONTyped(json, false);
}

export function AvailableRoomListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableRoomListEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'billing_product_id': !exists(json, 'billing_product_id') ? undefined : json['billing_product_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'is_available': json['is_available'],
        'is_configured': json['is_configured'],
    };
}

export function AvailableRoomListEntryToJSON(value?: AvailableRoomListEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'billing_product_id': value.billing_product_id,
        'type': value.type,
        'is_available': value.is_available,
        'is_configured': value.is_configured,
    };
}

